import { useCallback, useRef, useState } from "react";

/* Custom hook that combines useState and useRef to keep state and a mutable reference in sync. */
function useStateRef(initialValue) {
  const [state, setState] = useState(initialValue);
  const ref = useRef(initialValue);

  const setStateAndRef = useCallback((value) => {
    ref.current = value;
    setState(value);
  }, []);

  return [state, setStateAndRef, ref];
}

export default useStateRef;